
UserOptinImportController.$inject = ['$scope', '$mdDialog', 'company', 'sites', 'optins', 'UserOptinImportFactory', 'AlertingFactory', 'MediasFactory'];

export function UserOptinImportController($scope, $mdDialog, company, sites, optins, UserOptinImportFactory, AlertingFactory, MediasFactory) {

  $scope.ok = ok;
  $scope.cancel = cancel;
  $scope.onUploadOptinClick = onUploadOptinClick;

  $scope.sites = sites;
  $scope.optins = [];
  $scope.allOptins = optins;

  $scope.siteId = null;
  $scope.optinId = null;
  $scope.importFile = null;

  function ok() {

    MediasFactory.upload2(company.id, $scope.siteId, 'file', $scope.importFile,
      response => {
        AlertingFactory.success('optins/user/upload_success');

        UserOptinImportFactory.importOptin(company.id, $scope.siteId, $scope.optinId, { 'file_id': response['data']['file_id'] })
          .then(({ data }) => {
            AlertingFactory.info('audience/optin-import-counters', { translationData: data })
          })
          .catch(AlertingFactory.httpErrorHandler())
      },
      reason => {
        AlertingFactory.error(reason.data.error);
      });

    $mdDialog.hide({ 'type': 'ok' });
  }

  function cancel() {
    $mdDialog.cancel();
  }

  function onUploadOptinClick(event) {
    angular.element('#optin-file-input').click();
  }
}